import { Row } from 'antd'
import InvoiceTable from 'app/components/Core/Invoice/Table'
import CreateOptions from 'app/components/Core/Overview/CreateOptions'
import InfoNote from 'app/components/Core/Overview/Info'
import RentalTable from 'app/components/Core/Rental/Table'
import Button from 'app/components/UI-Elements/General/Button'
import KCol from 'app/components/UI-Elements/Layout/KCol'
import TabBar from 'app/components/UI-Elements/Layout/TabBar/TabBar'
import { RecordType } from 'app/constants/GlobalTypes'
import { ToolBox } from 'app/lib/hooks/toolBox'
import useTranslation from 'app/lib/hooks/useTranslation'
import { PageProps } from 'app/pages/typing'
import { Routes } from 'app/routes/Routes'
import * as React from 'react'
import { Link, useNavigate } from 'react-router-dom'

const getRoute = (recordType: string) => {
  switch (recordType) {
    case RecordType.rental:
      return Routes.Rental.collection().index
    case RecordType.invoice:
      return Routes.Invoice.collection().index
    default:
      return ''
  }
}

const Overview: React.FC<PageProps> = ({ route }) => {
  const { tRoute } = useTranslation({ scope: route.key })
  const { buttonId } = ToolBox.useId()
  const navigate = useNavigate()

  const renderFooter = (count: number, recordType: string) => {
    const route = getRoute(recordType)
    const id = buttonId({ recordType: RecordType.overview, action: `${recordType}.show_more` })

    return (
      <Row hidden={count === 0}>
        <KCol span={24} className="text-center">
          <Button id={id} type="link">
            <Link to={route}>{tRoute({ id: 'show_more' })}</Link>
          </Button>
        </KCol>
      </Row>
    )
  }

  return (
    <Row gutter={[24, 24]}>
      <InfoNote />
      <KCol card title={tRoute({ id: 'title.rentals' })} xs={24}>
        <RentalTable
          size="small"
          onRowClick={(rental) => navigate(Routes.Rental.member(rental.id.toString()).show)}
          params={{
            isRequested: true,
            runningRentals: true,
            scope: 'me',
            excludeCanceled: true
          }}
          pageSize={5}
          pagination={false}
          footer={(data) => renderFooter(data.length, RecordType.rental)}
        />
      </KCol>
      <KCol
        card
        title={tRoute({ id: 'title.invoices' })}
        xxl={20}
        xl={19}
        lg={24}
        md={24}
        sm={24}
        xs={24}>
        <InvoiceTable
          size="small"
          params={{ per_page: 5, total_entries: 5, filters: { status: 'unpaid' } }}
          footer={(data) => renderFooter(data.length, RecordType.invoice)}
        />
      </KCol>
      <KCol xxl={4} xl={5} lg={24} md={24} sm={24} xs={24}>
        <CreateOptions />
      </KCol>
      <TabBar />
    </Row>
  )
}

export default Overview
